import { Box, Typography } from '@mui/material'
import { RichTextEditor } from 'components/richtTextEditor'
import { inject, observer } from 'mobx-react'
import { Course } from 'models'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { RoutingStore } from 'stores'
import { handleAttachments } from './util'

export interface INoteProps {
  course?: Course
  routingStore?: RoutingStore
}

export const Notes = inject('routingStore')(
  observer((props: INoteProps) => {
    const { course } = props
    const { t } = useTranslation()
    if (!course) return null

    return (
      <Box
        sx={{
          margin: 'auto',
          width: '70rem',
          paddingTop: '8rem',
        }}
      >
        <Typography variant='h4' marginBottom={3}>
          {t('notes_title')}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            minHeight: '30rem',
          }}
        >
          <RichTextEditor
            onImageUploadBefore={(files, info, uploadHandler) =>
              handleAttachments(course, files, info, uploadHandler)
            }
            value    = {course?.notes || ""}
            onChange = {(notes) => course.set('notes', notes, true)}
          />
        </Box>
      </Box>
    )
  })
)
